import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { RatingFormControl } from "../Web/RatingFormControl";
import { XColumnContainer, XColumnContainerColumn } from "../../Containers";
import { LabelFormControl } from "../Web/LabelFormControl";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

let formData = new ExecutionData();
formData.values["rating"] = 8;

function getUI(): { form: FormConfiguration } {
    let ui = new FormConfiguration();
    let container = new XColumnContainer();
    let col1 = new XColumnContainerColumn();
    let col2 = new XColumnContainerColumn();
    col2.interControlSpacing = 20;

    container.add(col1);
    container.add(col2);
    ui.add(container);

    let label = new LabelFormControl();
    label.text = "Large Size";
    col1.add(label);

    let rating = new RatingFormControl();
    rating.label = "Please rate us";
    rating.valueName = "rating";
    rating.size = "large";
    rating.requiredOnAllOutcomes = false;
    col1.add(rating);

    label = new LabelFormControl();
    label.text = "Small Size";
    col2.add(label);

    rating = new RatingFormControl();
    rating.label = "Please rate us";
    rating.valueName = "rating";
    rating.size = "small";
    rating.requiredOnAllOutcomes = false;
    col2.add(rating);

    return { form: ui };
}

export const RatingStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return (
                <FormRuntime
                    form={ui.form}
                    formData={formData}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Rating",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as RatingFormControl;
                if (ctf) {
                    ctf.label = "label text";
                }
            }
            return (
                <FormRuntime
                    form={ui.form}
                    formData={formData}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Rating",
        "With Control Label",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as RatingFormControl;
                if (ctf) {
                    ctf.requiredOnAllOutcomes = true;
                }
            }
            return (
                <FormRuntime
                    form={ui.form}
                    formData={formData}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Rating",
        "With Validation",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let formData = new ExecutionData();
            formData.values["rating"] = 5.5;
            return (
                <FormRuntime
                    form={ui.form}
                    formData={formData}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Rating",
        "With Validation",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();
            for (let i = 0; i < controls.length; i++) {
                let ctf = controls[i] as RatingFormControl;
                ctf.showLabels = true;
                ctf.left = "bad";
                ctf.right = "good";
            }
            return (
                <FormRuntime
                    form={ui.form}
                    formData={formData}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Rating",
        "With Mark Labels",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();
            for (let i = 0; i < controls.length; i++) {
                let ctf = controls[i] as RatingFormControl;
                ctf.showLabels = false;
            }
            return (
                <FormRuntime
                    form={ui.form}
                    formData={formData}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Rating",
        "Without Mark Labels",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();
            for (let i = 0; i < controls.length; i++) {
                let ctf = controls[i] as RatingFormControl;
                ctf.count = 5;
            }
            return (
                <FormRuntime
                    form={ui.form}
                    formData={formData}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Rating",
        "5 Stars",
    ),
];
